<script>
	export let row = {};
	export let key = "";
</script>

<a href="/car-management/details/{row.vehicleId}" class="link link-text"
	>{row[key]}</a
>
